import { render, staticRenderFns } from "./AssistantTeacherProcessNav.vue?vue&type=template&id=0aa16d88&"
import script from "./AssistantTeacherProcessNav.vue?vue&type=script&lang=js&"
export * from "./AssistantTeacherProcessNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports